import React from "react";
import SubscriptionInfoPanel from "./SubscriptionInfoPanel/app";
import BrandsInfoPanel from "./BrandsInfoPanel";

interface RightSidePanelProps {
  viewModel: server.viewmodel.SystemSettingsMenuFrontModel
}

const SystemSettingsMenu: React.FC<RightSidePanelProps> = ({ viewModel }) => {
  return (
    <div className="system-settings-menu-wrapper">
      <BrandsInfoPanel brands={viewModel.brands} />
      <SubscriptionInfoPanel
        activeSubscription={viewModel.activeSubscription}
        nextSubscriptionType={viewModel.nextSubscriptionType}
        nextBillingCycle={viewModel.nextBillingCycle}
      />
    </div>
  );
};

export default SystemSettingsMenu;
